export default "__VITE_ASSET__DROE21qG__"